import {
  FiscalRegime,
  FiscalRegimeModel,
} from "@core/models/fiscal-regime.model";
import { Fund, FundModel } from "@core/models/fund.model";
import {
  ProductRiskProfile,
  ProductRiskProfileModel,
} from "@core/models/product-risk-profile.model";
import { TPagination } from "@custom-types/sorting";

import { ProductVersions } from "./product-versions.model";

export type TProductsPaginated = TPagination & {
  data: Array<ProductModel>;
};

export interface ProductModel {
  versions: Array<ProductVersions>;
  accountNumberPrefix: number;
  allowOwnDeposit: boolean;
  allowPeriodicDeposit: boolean;
  blocked: boolean;
  description: string;
  fiscalRegime: FiscalRegimeModel;
  fiscalRegimeId: string;
  funds: Array<FundModel>;
  id: string;
  incidentalPaymentInTax: boolean;
  minorAllowed: boolean;
  name: string;
  periodicPaymentInTax: boolean;
  productKind: number;
  productRiskProfiles: Array<ProductRiskProfileModel>;
  productPrivateIndividuals: boolean;
  secondaryOwnerAllowed: boolean;
  type: number;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class Product implements ProductModel {
  versions = new Array<ProductVersions>();
  accountNumberPrefix = 0;
  allowOwnDeposit = false;
  allowPeriodicDeposit = false;
  blocked = false;
  description = "";
  fiscalRegime = new FiscalRegime();
  fiscalRegimeId = "";
  funds = new Array<Fund>();
  id = "";
  incidentalPaymentInTax = false;
  minorAllowed = false;
  name = "";
  periodicPaymentInTax = false;
  productKind = 0;
  productRiskProfiles = new Array<ProductRiskProfile>();
  productPrivateIndividuals = false;
  secondaryOwnerAllowed = false;
  type = 0;
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: ProductModel) {
    if (!dto) {
      return;
    }
    this.versions = dto.versions;
    this.accountNumberPrefix = dto.accountNumberPrefix;
    this.allowOwnDeposit = dto.allowOwnDeposit;
    this.allowPeriodicDeposit = dto.allowPeriodicDeposit;
    this.blocked = dto.blocked;
    this.description = dto.description;
    this.fiscalRegime = dto.fiscalRegime;
    this.fiscalRegimeId = dto.fiscalRegimeId;
    this.funds = dto.funds;
    this.id = dto.id;
    this.incidentalPaymentInTax = dto.incidentalPaymentInTax;
    this.minorAllowed = dto.minorAllowed;
    this.name = dto.name;
    this.periodicPaymentInTax = dto.periodicPaymentInTax;
    this.productKind = dto.productKind;
    this.productRiskProfiles = dto.productRiskProfiles;
    this.secondaryOwnerAllowed = dto.secondaryOwnerAllowed;
    this.type = dto.type;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
